<svg *ngIf="values.length > 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd"
        d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
        clip-rule="evenodd"/>
</svg>
<div class="wrapper">
  <span *ngIf="values.length > 1">{{ label }}</span>
  <span *ngIf="values.length == 0">
    <div class="text-placeholder w20"></div>&nbsp;
    <div class="text-placeholder w70"></div>&nbsp;
    <div class="text-placeholder w40"></div>&nbsp;
  </span>
  <clipboard *ngIf="values.length == 1" [value]="values[0]"></clipboard>
  <ul class="content" *ngIf="values.length > 0 && values.length != 1">
    <li *ngFor="let value of values">
      <clipboard [value]="value" [show]="true"></clipboard>
    </li>
  </ul>
</div>

